export const SUPPORTED_TYPES = {
  text: 'text',
  number: 'number',
};

export const SUPPORTED_OPERATORS = {
  gt: 'Is Greater Than ',
  gte: 'Is Greater Or Equal To ',
  lt: 'Is Less Than ',
  lte: 'Is Less Than Or Equal To ',
  eq: 'Is Equal To ',
  neq: 'Is Not Equal To ',
  contains: 'Contains ',
  empty: 'Is Empty',
  nempty: 'Is Not Empty',
};

export const RULES_TYPE = [
  {
    title: 'And',
    value: 'AND',
  },
  {
    title: 'Or',
    value: 'OR',
  },
];

export const FIXED_VALUE_OPERATORS = {
  empty: {
    value: '',
  },
  nempty: {
    value: '',
  },
};

export const SUPPORTED_VARIABLES = {
  page_url: {
    label: 'Page URL',
    type: 'text',
    metaKeys: [],
  },
  query_param: {
    label: 'Query Params',
    type: 'text',
    metaKeys: [
      {
        key: 'key',
        title: 'Key',
        type: 'string',
      },
    ],
  },
};

export const SUPPORTED_OPERATORS_BY_TYPE = {
  [SUPPORTED_TYPES.text]: ['eq', 'neq', 'contains', 'empty', 'nempty'],
  [SUPPORTED_TYPES.number]: ['gt', 'gte', 'lt', 'lte', 'eq', 'neq'],
};
